jQuery(document).ready(function($) {

	if ( $('.responsive-slider--wrapper').length > 0 ) {

		var slider  = $('.responsive-slider--wrapper');
		// var options = JSON.stringify(slider.data('flickity'));

		slider.flickity({
			cellAlign: 'left',
	  	contain: true,
			wrapAround : true,
			prevNextButtons : true,
			pageDots : false
		});

		$(window).resize(function() {
			slider.flickity('resize');
		});

	}

	if ( $('.team-slider--wrapper').length > 0 ) {

		var slider  = $('.team-slider--wrapper');
		// var options = JSON.stringify(slider.data('flickity'));

		slider.flickity({
			cellAlign: 'left',
	  	contain: true,
			wrapAround : true,
			prevNextButtons : true,
			pageDots : false,
			draggable: false
		});

		$(window).resize(function() {
			slider.flickity('resize');
		});

	}

});
